import Spinner from "react-bootstrap/Spinner";
import styles from "./dcui-theming-loading-spinner.less";

type DCUIThemingLoadingSpinnerProps = {
    loadingText: string;
};

export const DCUIThemingLoadingSpinner = (props: DCUIThemingLoadingSpinnerProps) => {
    const { loadingText } = props;

    return (
        <div className={styles.dcuiThemingLoadingSpinner}>
            <div className={styles.spinnerContainer}>
                <Spinner animation="border" />
            </div>
            {loadingText && (
                <div className={styles.textContainer}>
                    <span>{loadingText}</span>
                </div>
            )}
        </div>
    );
};